import * as React from 'react';
import { Block } from 'emotion-jsxstyle';
import { EntityActions, EntityType } from 'common/entity';
import { AppState } from 'common/models/AppState';
import { InfiniteList } from 'common/components/InfiniteList';
import { Member } from 'common/api/models/Member';
import { EligibleItemMapping } from 'common/api/models/EligibleItem';
import { Loading } from 'common/components/Loading';
import { VoucherApi } from 'common/api/resources/Voucher';
import { DayDialog } from 'common/components/dialogs/DayDialog';
import { ConfirmDialog } from 'common/components/dialogs/ConfirmDialog';
import { BadgeBackageFullFillDropDownDialog } from 'common/components/dialogs/BadgePackageFullFillDialog';
import * as acl from 'common/utils/acl';
import { UserPermissions } from 'common/api/models/UserPermissions';
import { VoucherEditDialog } from 'common/components/dialogs/VoucherEditDialog';
import { RowActionButton } from 'common/components/RowActionButton';

export interface MembersBadgesProps {
  appState: AppState;
  entityActions: EntityActions;
  member?: Member;
  onEdit: (org: Member) => void;
}
export interface MembersBadgesState {
  isLoading: boolean;
  eligibleItems: any[];
  next?: number;
  error?: string;
  extendEligibleUser?: Member;
  voucherId?: string;
  expireDate?: string;
  activatedDate?: string;
  originalExpireDate?: string;
  member?: Member;
  drawingStatus?: string;
  applicationStatus?: string;
  voucher?: any;
  openBadgeFullFillment?: string;
  reassignDialogSelect: boolean;
  cancelDialogSelect: boolean;
  superUserEditDialogSelect: boolean;
  resendWelcomeEmailVoucher?: any;
}

export class MembersBadges extends React.Component<MembersBadgesProps, MembersBadgesState> {
  state: MembersBadgesState = {
    isLoading: false,
    eligibleItems: [],
    voucherId: '',
    reassignDialogSelect: false,
    cancelDialogSelect: false,
    superUserEditDialogSelect: false,
  };

  componentDidMount() {
    this.reload();
  }

  reload = () => {
    if (this.props.member) {
      this.props.entityActions.refetch(EntityType.MEMBER, this.props.member!.id!);
      VoucherApi.getVouchersByMember(this.props.member!.id!, 'badge')
        .then(res => {
          // this.reload();
          let vouchers = Object.keys(res).map(key => [Number(key), res[key]]);
          this.setState({ isLoading: false, eligibleItems: vouchers });
        })
        .catch(e => {
          this.setState({ error: e.response.data.message });
          this.setState({ isLoading: false });
        });
    }
  };

  cancelExam = () => {
    VoucherApi.cancelVoucher(this.state.voucherId!)
      .then(() => {
        this.setState({
          voucherId: undefined,
        });
        this.reload();
      })
      .catch(e => {
        this.setState({ isLoading: false });
      });
  };

  resendWelcomeEmail = () => {
    this.setState({ isLoading: true });
    VoucherApi.resendwelcomeemail(this.state.resendWelcomeEmailVoucher.id)
      .then(res => {
        this.setState({ resendWelcomeEmailVoucher: undefined, isLoading: false });
        // this.reload();
      })
      .catch(e => {
        this.setState({ error: e.response.data.message, isLoading: false });
      });
  };

  openResendWelcomeEmailDialog = (voucher: any) => {
    this.setState({
      resendWelcomeEmailVoucher: voucher,
    });
  };

  closeDialogModals = () => {
    this.setState({
      extendEligibleUser: undefined,
      voucherId: undefined,
      drawingStatus: undefined,
      applicationStatus: undefined,
      openBadgeFullFillment: undefined,
      resendWelcomeEmailVoucher: undefined,
    });
  };

  openExtendExamDialog = (voucher: any, voucherId: any, expireDate: any, originalExpireDate: any) => {
    this.setState({
      extendEligibleUser: voucher,
      voucherId: voucherId,
      expireDate: expireDate,
      originalExpireDate: originalExpireDate,
    });
  };
  openCancelExamDialog = (voucherId: any) => {
    this.setState({
      voucherId: voucherId,
      cancelDialogSelect: true,
    });
  };

  openSuperUserEditDialog = (
    voucher: any,
    voucherId: any,
    expireDate: any,
    activatedDate: any,
    originalExpireDate: any
  ) => {
    this.setState({
      extendEligibleUser: voucher,
      voucherId: voucherId,
      expireDate: expireDate,
      activatedDate: activatedDate,
      originalExpireDate: originalExpireDate,
      superUserEditDialogSelect: true,
    });
  };

  openBadgeFullFillDialog = (voucher: any, voucherId: any, badgePackageFullfilled: any) => {
    this.setState({
      voucher: voucher,
      voucherId: voucherId,
      openBadgeFullFillment: badgePackageFullfilled ? 'YES' : 'NO',
    });
  };

  reloadAfterSave = () => {
    this.closeDialogModals();
    this.reload();
  };

  handleVoucherReassign = () => {
    // console.log('Reassign...');
    this.setState({ isLoading: true });
    VoucherApi.reassignVoucher(this.state.voucherId ? this.state.voucherId : '', {})
      .then(res => {
        this.setState({ voucherId: undefined, reassignDialogSelect: false });
        this.reload();
      })
      .catch(e => {
        this.setState({ error: e.response.data.message });
        this.setState({ isLoading: false });
      });
  };

  handleCancelDialog = () => {
    this.setState({
      extendEligibleUser: undefined,
      reassignDialogSelect: false,
      cancelDialogSelect: false,
      expireDate: undefined,
      activatedDate: undefined,
      voucherId: undefined,
      voucher: undefined,
      superUserEditDialogSelect: false,
      error: undefined,
    });
  };

  render() {
    return (
      <Block marginBottom="2rem">
        <InfiniteList hasMore={!!this.state.next} isLoading={this.state.isLoading} onLoadMore={this.reload}>
          <table
            className="table table-striped table-hover table-clickable"
            style={{ width: '100%' }}
            data-testid="membersBadges"
          >
            <thead>
              <tr>
                <th>Product Name</th>
                <th>Exam code</th>
                <th>Exam status</th>
                <th>Failed Count</th>
                <th>Expiration Date</th>
                <th>Badge Fullfillment Completed</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {!this.state.isLoading &&
                !this.state.error &&
                this.state.eligibleItems.length === 0 && (
                  <tr>
                    <td colSpan={6}>No results found.</td>
                  </tr>
                )}
              {this.state.error && (
                <tr>
                  <td colSpan={6}>
                    <div className="alert alert-danger">{this.state.error}</div>
                  </td>
                </tr>
              )}

              {this.state.eligibleItems.length > 0 &&
                this.state.eligibleItems.length &&
                this.state.eligibleItems.map((u, i) => {
                  return u.map((item: EligibleItemMapping, index: number) => {
                    let examCode = '';
                    let examStatus = '';
                    let passFail = '';
                    let failedCount = 0;
                    let badgePackageFullfilled = item.badgePackageFullfilled ? 'Yes' : 'No';

                    if (item.kryterionExams) {
                      item.kryterionExams!.map(exam => {
                        examCode = exam.examCode!;
                        examStatus = exam.status!;
                        passFail = exam.passFail!;
                        if (passFail && passFail.length > 0) {
                          examStatus = passFail;
                        }
                        if (passFail && passFail === 'FAIL') {
                          failedCount++;
                        }
                      });
                    }
                    return (
                      item.productName && (
                        <tr key={index}>
                          <td>
                            {' '}
                            {item.productName} <br />
                            {acl.hasPermission(this.props.appState, UserPermissions.Permissions.SUPERUSER) && (
                              <>
                                <span
                                  className="badge badge-pill badge-danger"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() =>
                                    this.openSuperUserEditDialog(
                                      u,
                                      item.id,
                                      item.expireDate,
                                      item.activatedDate,
                                      item.originalExpireDate
                                    )
                                  }
                                >
                                  <i className="fa fa-pencil ml-2" />
                                  <span> Superuser Edit</span>
                                </span>
                              </>
                            )}
                          </td>
                          <td> {examCode} </td>
                          <td>
                            {examStatus} <br />
                            {examStatus &&
                              examStatus === 'FAIL' && (
                                <>
                                  <span
                                    className="badge badge-pill badge-danger"
                                    onClick={() => {
                                      this.setState({
                                        reassignDialogSelect: true,
                                        voucherId: item.id,
                                      });
                                    }}
                                  >
                                    <i className="fa fa-ban ml-2" />
                                    <span> Re-assign</span>
                                  </span>
                                </>
                              )}
                            {/* {examStatus &&
                              examStatus !== 'CANCELLED' && (
                                <>
                                  <span
                                    className="badge badge-pill badge-danger"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => this.openCancelExamDialog(item.id)}
                                  >
                                    <i className="fa fa-ban ml-2" />
                                    <span> Cancel</span>
                                  </span>
                                </>
                              )} */}
                          </td>

                          <td>{failedCount}</td>
                          <td>
                            {item.expireDate!.substring(0, item.expireDate!.indexOf('T'))}
                            <br />
                            {examStatus !== 'CANCELLED' &&
                              examStatus !== 'PASS' && (
                                <>
                                  <span
                                    className="badge badge-pill badge-primary"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() =>
                                      this.openExtendExamDialog(u, item.id, item.expireDate, item.originalExpireDate)
                                    }
                                  >
                                    <i className="fa fa-arrow-circle-right ml-2" />
                                    <span> Extend</span>
                                  </span>
                                </>
                              )}
                          </td>
                          <td>
                            {badgePackageFullfilled}
                            {examStatus === 'PASS' && (
                              <>
                                <div>
                                  <span
                                    className="badge badge-pill badge-primary"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() =>
                                      this.openBadgeFullFillDialog(
                                        u,
                                        item.id,
                                        item.badgePackageFullfilled ? true : false
                                      )
                                    }
                                  >
                                    <i className="fa fa-arrow-circle-right ml-2" />
                                    <span> Update</span>
                                  </span>
                                </div>
                              </>
                            )}
                          </td>
                          <td>
                            <RowActionButton
                              item={item}
                              icon="envelope-o"
                              onClick={this.openResendWelcomeEmailDialog}
                            />
                          </td>
                        </tr>
                      )
                    );
                  });
                })}

              {this.state.isLoading && (
                <tr>
                  <td colSpan={7}>
                    <Loading />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </InfiniteList>

        <ConfirmDialog
          title="Cancel Exam"
          message={`Are you sure you want to cancel this exam?`}
          isOpen={!!this.state.voucherId}
          onConfirm={this.cancelExam}
          onCancel={this.closeDialogModals}
          error={this.state.error}
          loadingMessage="Sending..."
        />

        <DayDialog
          title="Extend Eligibility"
          isOpen={!!this.state.extendEligibleUser}
          voucher={this.state.voucherId!}
          member={this.state.member}
          expireDate={this.state.expireDate}
          originalExpireDate={this.state.originalExpireDate}
          error={this.state.error}
          onSave={this.reloadAfterSave}
          onCancel={this.closeDialogModals}
        />

        <VoucherEditDialog
          title="Edit Record Dates"
          isOpen={!!this.state.extendEligibleUser && !!this.state.activatedDate}
          voucher={this.state.voucherId!}
          member={this.state.member}
          expireDate={this.state.expireDate}
          originalExpireDate={this.state.originalExpireDate}
          activatedDate={this.state.activatedDate}
          error={this.state.error}
          onSave={this.reloadAfterSave}
          onCancel={this.closeDialogModals}
        />

        <BadgeBackageFullFillDropDownDialog
          title="Update Package Fullfillment Status"
          isOpen={!!this.state.openBadgeFullFillment}
          voucher={this.state.voucherId!}
          member={this.state.member}
          onSave={this.reloadAfterSave}
          onCancel={this.closeDialogModals}
          error={this.state.error}
          badgePackageFullfilled={this.state.openBadgeFullFillment}
        />

        <ConfirmDialog
          isOpen={this.state.reassignDialogSelect}
          title="Reassign Badge Exam"
          error={this.state.error}
          message="Are you sure you want to reassign this badge exam to this user?"
          onConfirm={this.handleVoucherReassign}
          onCancel={this.handleCancelDialog}
        />

        <ConfirmDialog
          title="Resend Welcome/Instructional Email"
          message={`Are you sure you want to resend the Welcome and Instruction email for this record?`}
          isOpen={!!this.state.resendWelcomeEmailVoucher}
          onConfirm={this.resendWelcomeEmail}
          onCancel={this.closeDialogModals}
          error={this.state.error}
          isLoading={this.state.isLoading}
          loadingMessage="Sending..."
        />
      </Block>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Members/MembersBadges.tsx